import React from 'react';
import { View, Text } from 'react-native';
const MenuHomeScreen = () => {
    return (
        <View style={{alignItems: 'center', justifyContent: 'center', paddingTop: 50}}>
          <Text>Menu Screen</Text>
        </View>
    );
};
export default MenuHomeScreen;